import { reportHandledException } from '@/lib/error-reporting'
import type { AnonymousClientTrim } from '@kiao-voice/api-contract/anonymous-trial'
import { readSliceBytes } from './read-slice'

type Sniffed = AnonymousClientTrim | 'unknown'

/** 僅讀 16 bytes；格式未知或讀取失敗時不宣告裁切能力。 */
export async function sniffFile(file: File): Promise<AnonymousClientTrim | null> {
  try {
    const kind = sniff(await readSliceBytes(file, 0, 16))
    return kind === 'unknown' ? null : kind
  } catch (caughtError) {
    reportHandledException(caughtError, { source: 'features/anonymous-trial/trim/sniff.ts' })
    return null
  }
}

export function sniff(head: Uint8Array): Sniffed {
  if (head.length < 6) return 'unknown'
  if (ascii(head, 0, 6) === '#!AMR\n' || ascii(head, 0, 9) === '#!AMR-WB\n') return 'amr'
  if (ascii(head, 0, 4) === 'OggS') return 'ogg'
  if (head[0] === 0xff && (head[1] & 0xf6) === 0xf0) return 'aac'
  if (ascii(head, 4, 4) === 'ftyp') return 'mp4'
  if (ascii(head, 0, 4) === 'RIFF' && ascii(head, 8, 4) === 'WAVE') return 'wav'
  if (ascii(head, 0, 3) === 'ID3') return 'mp3'
  // 沒有 ID3 標頭的 MP3 直接以 frame sync 開頭。
  if (head[0] === 0xff && (head[1] & 0xe0) === 0xe0) return 'mp3'
  return 'unknown'
}

function ascii(bytes: Uint8Array, at: number, length: number): string {
  let out = ''
  for (let i = 0; i < length; i += 1) out += String.fromCharCode(bytes[at + i])
  return out
}
